module.exports = __webpack_public_path__ + "img/logo.e871cd9e.png";